import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=64b9630e&lang=pug"
import script from "./Header.vue?vue&type=script&lang=coffee"
export * from "./Header.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports